import { gql } from '@apollo/client';

export const SETUP_DEFAULT_EXIT_STRATEGIES = gql`
  mutation SetupDefaultExitStrategies($portfolioId: ID!) {
    setupDefaultExitStrategies(portfolioId: $portfolioId) {
      success
      error
      updatedCount
    }
  }
`;


